
import get from 'lodash/get';

export default {
  name: 'i18n',
  methods: {
    getStringFromOption(defaultOption) {
      if (typeof defaultOption === 'string') {
        return defaultOption;
      }
      return get(defaultOption, 'defaultValue', '');
    },
    getString(key, defaultOption) {
      if (!this.$t) { // i18n tool is not available in dashboard
        return this.getStringFromOption(defaultOption);
      }

      const result = this.$t(key, defaultOption);
      if (!result) {
        return this.getStringFromOption(defaultOption);
      }
      return result;
    },
  },
};
